import { call, put, takeEvery } from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';
import * as Actions from '../actions/analysisSimulatorAction';
import * as Apis from '../apis/annalysisSimulatorApi';

function* listSaga(action: ActionType<typeof Actions.list.request>) {
  try {
    const { searchParams, page } = action.payload;
    const res = yield call(Apis.analysisSimulator.list, searchParams, page);
    const {
      data: { items, total },
      count
    } = res;

    yield put(
      Actions.list.success({
        data: items,
        count: count,
        total,
        page: res.data.page
      })
    );
  } catch (error) {
    yield put(Actions.list.failure(error));
  }
}

function* detailSaga(action: ActionType<typeof Actions.detail.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.analysisSimulator.detail, id);
    yield put(Actions.log.request(id));
    const { data } = res;
    yield put(
      Actions.detail.success({
        data: data
      })
    );
  } catch (error) {
    yield put(Actions.detail.failure(error));
  }
}

function* stcsSaga(action: ActionType<typeof Actions.stcs.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.analysisSimulator.stcsList, id);
    yield put(Actions.log.request(id));
    const { data, count } = res;
    yield put(
      Actions.stcs.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.detail.failure(error));
  }
}

function* logSaga(action: ActionType<typeof Actions.log.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.analysisSimulator.logList, id);
    const { data } = res;

    yield put(
      Actions.log.success({
        log: data
      })
    );
  } catch (error) {
    yield put(Actions.log.failure(error));
  }
}

export function* analysisSimulatorSaga() {
  yield takeEvery(Actions.list.request, listSaga);
  yield takeEvery(Actions.detail.request, detailSaga);
  yield takeEvery(Actions.stcs.request, stcsSaga);
  yield takeEvery(Actions.log.request, logSaga);
}
